<div class="link">
  <a [routerLink]="routerLinks" *ngIf="!regularLink" [class]="anchorTagClass"
    >{{ text }}<i *ngIf="icon" [class]="icon"></i>
  </a>
  <a
    [href]="href?.toLowerCase()?.startsWith('http') ? href : '//' + href"
    *ngIf="regularLink"
    [class]="anchorTagClass"
    [target]="target || '_self'"
    >{{ text }}<i *ngIf="icon" [class]="icon"></i>
  </a>
</div>
